import React, { useState } from 'react';
import { emergencyAPI } from '../services/api';
import { Phone, AlertTriangle, User, MapPin } from 'lucide-react';
import { toast } from 'sonner';
import { CrisisModal } from '../components/CrisisModal';

export const Emergency = () => {
  const [showCrisisModal, setShowCrisisModal] = useState(false);
  const [confirmSOS, setConfirmSOS] = useState(false);

  const handleSOSClick = async () => {
    if (!confirmSOS) {
      setConfirmSOS(true);
      setTimeout(() => setConfirmSOS(false), 5000);
      return;
    }

    try {
      await emergencyAPI.logEvent({ event_type: 'sos_button_pressed' });
      window.location.href = 'tel:112';
    } catch (error) {
      console.error('Failed to log emergency event:', error);
      window.location.href = 'tel:112';
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F2EB] py-8" data-testid="emergency-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <AlertTriangle className="w-16 h-16 text-[#D66D6D] mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-[#2D3A3A] mb-2" style={{ fontFamily: 'Nunito, sans-serif' }}>Emergency Support</h1>
          <p className="text-[#6B7C7C]">Quick access to crisis resources and emergency services</p>
        </div>

        {/* SOS Button */}
        <div className="bg-white rounded-2xl p-8 mb-8 card-soft text-center">
          <h2 className="text-2xl font-bold text-[#2D3A3A] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Emergency Services</h2>
          <p className="text-[#6B7C7C] mb-6">Press the button below to call 112 immediately</p>
          <button
            onClick={handleSOSClick}
            className={`w-48 h-48 rounded-full text-white font-bold text-2xl emergency-btn mx-auto ${
              confirmSOS ? 'bg-[#8FB339]' : 'bg-[#D66D6D]'
            }`}
            data-testid="sos-button"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            {confirmSOS ? 'TAP TO CALL' : 'SOS'}
          </button>
          {confirmSOS && (
            <p className="text-[#D66D6D] mt-4 font-semibold">Tap again to confirm and call 112</p>
          )}
          <p className="text-xs text-[#6B7C7C] mt-4 max-w-md mx-auto">
            <strong>Disclaimer:</strong> Use only in genuine medical emergencies. This will initiate a call to emergency services.
          </p>
        </div>

        {/* Crisis Resources */}
        <div className="bg-gradient-to-br from-[#79A8E0] to-[#6897CF] rounded-2xl p-8 mb-8 text-white">
          <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Mental Health Crisis</h2>
          <p className="mb-6">If you're experiencing a mental health crisis, help is available 24/7</p>
          <button
            onClick={() => setShowCrisisModal(true)}
            className="px-8 py-4 rounded-full bg-white text-[#79A8E0] font-bold hover:scale-105 transition-transform"
            data-testid="view-crisis-resources"
          >
            View Crisis Resources
          </button>
        </div>

        {/* Important Information */}
        <div className="bg-white rounded-2xl p-6 card-soft">
          <h3 className="text-xl font-bold text-[#2D3A3A] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Important Information</h3>
          <div className="space-y-4 text-[#2D3A3A]">
            <div className="flex items-start space-x-3">
              <AlertTriangle className="w-5 h-5 text-[#E0C079] mt-1" />
              <p>This app is not a substitute for professional medical care or emergency services.</p>
            </div>
            <div className="flex items-start space-x-3">
              <Phone className="w-5 h-5 text-[#79A8E0] mt-1" />
              <p>For life-threatening emergencies, always call 112 or your local emergency number.</p>
            </div>
            <div className="flex items-start space-x-3">
              <User className="w-5 h-5 text-[#7C9A92] mt-1" />
              <p>If you're experiencing suicidal thoughts, call 788789882 for the Suicide & Crisis Lifeline.</p>
            </div>
          </div>
        </div>
      </div>

      <CrisisModal isOpen={showCrisisModal} onClose={() => setShowCrisisModal(false)} />
    </div>
  );
};